import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const isDefaultOperationSucceeded = (response: DefaultOperationSuccessResponse | undefined) => response?.data?.[0]?.success === true;
